import { Route } from "react-router-dom";
import MarkdownPage from "../projects/MarkdownPage";



const AllProjectRoutes = [
    <Route path="/projects/project-crumple" element={<MarkdownPage filename="project-crumple"  />} />,

]

export default AllProjectRoutes;